module.exports = __webpack_public_path__ + "static/img/class_11.37562f9f.jpg";